module.exports = __webpack_public_path__ + "static/img/activity.5ea8e21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/activity.png
// module id = FQ0t
// module chunks = 4